import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_AGGREGATE_DATA} from '../../api';
import $ from "jquery";
import {capitalize} from "../../utils/capitalize";
import cogoToast from "cogo-toast";
import moment from "moment/moment";
import {submission} from "../../api/app";
import DTLeaderBoard from "../../components/layout/DTLeaderBoard";

let searchableFields = [
    { field: 'user.name', isNumeric: false },
    { field: 'assignment.social', isNumeric: false },
    { field: 'assignment.name', isNumeric: false }
]

const Submission = () => {

    document.title = "Submission";

    const token = localStorage.getItem('jwtToken');
    const [id, setId] = useState(new Date().getTime());

    useEffect(() => {
        let table = $('#message_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Submission Data</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "submission",
                        searchableFields,
                        filter: {},
                        populate: [
                            {
                                path: "task",
                                model: "task",
                                populate: {
                                    path: "assignment",
                                    model: "assignment",
                                }
                            },
                            {
                                path: "user",
                                model: "user"
                            }
                        ],
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="#/user/${data?.user?._id}" class="nav-label tx-color-01" target="_blank"> ${capitalize(data?.user?.name || "User not found")}</a></nav>`
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return capitalize(data?.task?.assignment?.social || "Task not found");
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return `<nav class="nav nav-icon-only"><a href="${data.url}" class="nav-link" target="_blank"><i class="fa fa-eye"></i> View Link</a></nav>`
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return moment(data.date.iso).format("Do MMM, YYYY HH:mm")
                    },
                    "targets": 4
                },
                {
                    "render": function () {
                        return `<nav class="nav nav-icon-only"><a href="#" class="nav-link delete_submission"><i class="fa fa-trash"></i> Delete</a></nav>`
                    },
                    "targets": 5
                }
            ]
        });

        table.on('click', '.delete_submission', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this submission?`);
            $('#delete-data').unbind("click").click(function(){

                $("#modalConfirm").modal("hide");
                $(".modal-backdrop").remove();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                submission("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Submission successfully removed.", {position: "top-right"});
                    }
                });
            });

            $("#modalConfirm").modal({ backdrop: 'static', focus: false, show: true });
        });

        $('#message_table tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            if(d.raw?.task && Object.keys(d.raw.task).length === 0) {
                return (
                    '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                    '<tr>' +
                    '<td>Subject:</td>' +
                    '<td>' +
                    'No Task Found' +
                    '</td>'+
                    '</tr>' +
                    '</tr>' +
                    '</table>'
                )
            }

            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Subject:</td>' +
                '<td>' +
                d.raw?.task?.assignment?.subject +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '<tr>' +
                '<td>Task:</td>' +
                '<td>' +
                d.raw?.task?.description +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '<tr>' +
                '<td>Type:</td>' +
                '<td class="text-capitalize">' +
                d.raw?.task?.assignment?.type +
                '</td>'+
                '</tr>' +
                '</tr>' +
                '</table>'
            );
        }

        return () => {
            table.destroy();
        }

    }, []);

    const handleLeaderboard = () => {
        setId(new Date().getTime());
        $("#modalLeaderboard").modal("show");
    }

    const reloadTable = () => {
        $('#message_table').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Submission</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Submission</h4>
                    </div>
                    <button className="btn btn-sm pd-x-15 btn-secondary btn-uppercase mg-l-5 outline-none" onClick={handleLeaderboard.bind()}><i className="wd-10 mg-r-5 fa fa-signal"></i> Leaderboard</button>
                </div>

                <div className="row row-sm">
                    <div className="col-md-12 mt-3">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Submissions</h6>
                                <div className="d-flex tx-18">
                                    <a href="javascript:void(0)" className="link-03 lh-0 mg-l-10" onClick={() => reloadTable()}><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="message_table" className="table" style={{width: "100%"}}>
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Social</th>
                                        <th className="wd-20p">Link</th>
                                        <th className="wd-20p">Date</th>
                                        <th className="wd-20p">Actions</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalLeaderboard" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel6">Leaderboard</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => $("#tx-support-level").text("Select Date")}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <DTLeaderBoard id={id}/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Submission;
